import { tw } from "@noones/ui/tw";
import { ApiComponentType } from "@store/types";
import React from "react";
import { StatusCard } from "./StatusCard";

type StatusCardListComponentType = {
    title: string;
    components: ApiComponentType[];
};

export const StatusCardListComponent = ({ title, components }: StatusCardListComponentType) => {
    return (
        <div className={tw.bg_white.rounded_xl.w_full.p_4}>
            <div className={tw.text_button_big.font_semibold.p_2.bg_light_grey.rounded_xl.mb_4}>
                {title}
            </div>

            <div className={tw.flex.flex_col.gap_4}>
                {components.map((component, i) => (
                    <StatusCard key={i} name={component.name} status={component.status} />
                ))}
            </div>
        </div>
    );
};
